/** @jsx h */
import { h, Component, JSX } from 'preact';
import { sendCreativeCloseButtonClick } from '../../../../../../common/js/TrackAnalyticsHelper';
import CustomizedControl from '../../../../../../common/components/customized-control';
import CloseControl from '../../../../../../common/components/close-control';
import { ClickArea } from '../../../../../../common/components/click-area';
import { ButtonBase } from '../../../../../../common/components/button-base';

interface ControlStyle {
  backgroundColor: string;
  backgroundOpacity: number;
  labelColor: string;
  labelOpacity: number;
}

interface CloseItemProps {
  closeButtonSize: number;
  onClose: (e: MouseEvent) => void;
  _debug?: boolean;
  closingScheduledIn?: number;
  showCloseDelay: boolean;
  controlStyle: ControlStyle;
  useCrossCloseButton: boolean;
  elapsedTime: number;
  clickCloseTime?: number;
}

export class CloseItem extends Component<CloseItemProps> {
  constructor(props: CloseItemProps) {
    super(props);
  }

  render(): JSX.Element {
    const {
      closeButtonSize,
      onClose,
      _debug,
      closingScheduledIn,
      showCloseDelay,
      controlStyle,
      useCrossCloseButton,
      elapsedTime,
      clickCloseTime
    } = this.props;

    const ClickAreaChildren =
      !closingScheduledIn || (closingScheduledIn && showCloseDelay) ? (
        <CustomizedControl
          id="continue"
          controlStyle={controlStyle}
          style={{ padding: 9, minHeight: 0 }}
        >
          <CloseControl
            closingScheduledIn={closingScheduledIn}
            isCross={useCrossCloseButton}
            elapsedTime={elapsedTime}
            clickCloseTime={clickCloseTime}
          />
        </CustomizedControl>
      ) : (
        ''
      );

    return (
      <ButtonBase
        style={{
          transform: `scale(${closeButtonSize / 100}, ${closeButtonSize /
            100})`,
          WebkitTransform: `scale(${closeButtonSize / 100}, ${closeButtonSize /
            100})`,
          transformOrigin: useCrossCloseButton ? 'top right' : 'bottom right',
          WebkitTransformOrigin: useCrossCloseButton
            ? 'top right'
            : 'bottom right'
        }}
        aria-label="ogury_close_button"
        data-zone="continue_button"
        id="continue_button"
      >
        <ClickArea
          onTouchStart={(e: TouchEvent) => e.stopPropagation()}
          onClick={(e: MouseEvent) => {
            e.stopPropagation();
            sendCreativeCloseButtonClick();
            onClose(e);
          }}
          debug={_debug}
          canIncreaseAreaForTablet={false}
        >
          {ClickAreaChildren}
        </ClickArea>
      </ButtonBase>
    );
  }
}
